import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, TextField, Box, Divider
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const ConfirmationDialog = (
  {
    open = true, handleClose, handleAction, message, alertMessage, addConfirmationText = false, lan
  }) => {
  const [validText, setValidText] = useState('');
  const [noValidText, setNoValidText] = useState(true);
  const onAction = () => {
    if (addConfirmationText) {
      if (validText === lan.continue.toUpperCase()) {
        handleAction();
      } else {
        setNoValidText(false);
      }
    } else {
      handleAction();
    }
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        <WarningAmberIcon color="error" sx={{ fontSize: 40, mb: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" align="center" sx={{ mb: 1 }}>
          {message}
        </Typography>
        {alertMessage && (
          <Typography
            variant="body2"
            color="error"
            align="center"
            sx={{ fontStyle: 'italic', mb: 2 }}
          >
            *{alertMessage}
          </Typography>
        )}
        {addConfirmationText && (
          <>
            <Typography
              variant="body2"
              align="center"
              sx={{ fontStyle: 'italic', mb: 1 }}
            >
              *{lan.writeTheWordContinue}
            </Typography>

            <TextField
              variant="outlined"
              fullWidth
              size="small"
              value={validText}
              onChange={(e) => { setValidText(e.target.value); setNoValidText(true); }}
              error={!noValidText}
              helperText={!noValidText ? lan.error || 'Invalid text' : ' '}
            />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', mb: 1 }}>
        <Button
          sx={{ backgroundColor: '#dc5c87' }}
          variant="contained"
          color="success"
          onClick={onAction}
          id="id-confirmation-accept"
        >
          {lan.accept}
        </Button>
        <Button
          sx={{ color: '#dc5c87', border: '1px solid #dc5c87' }}
          variant="outlined"
          color="error"
          onClick={handleClose}
          id="id-confirmation-cancel"
        >
          {lan.cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
